module.exports = __webpack_public_path__ + "static/media/about.8250014f.png";